import React from 'react';
import { FileTextOutlined, RightOutlined } from '@ant-design/icons';

export default function ThinkingProcessResourceLine({ fallbackLine, onUICardAction, resource }) {
  if (!resource?.action) {
    return (
      <span className="flare-thinking-process-source">
        <FileTextOutlined aria-hidden="true" />
        <span>{fallbackLine}</span>
      </span>
    );
  }
  const actionLabel = String(resource.action.label || '预览资料').trim();
  return (
    <button
      aria-label={`${actionLabel}：${resource.label}`}
      className="flare-thinking-process-source flare-thinking-process-source-button"
      onClick={() => onUICardAction?.(resource.action)}
      type="button"
    >
      <FileTextOutlined aria-hidden="true" />
      <span className="flare-thinking-process-source-content">
        <span className="flare-thinking-process-source-name">{resource.label}</span>
        {resource.meta ? <span className="flare-thinking-process-source-meta">{resource.meta}</span> : null}
      </span>
      <span className="flare-thinking-process-source-action">
        <span>预览</span>
        <RightOutlined aria-hidden="true" />
      </span>
    </button>
  );
}
